module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Prelude")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("SCIENCE, MAGIC AND THE PREHISTORY OF THE BIG FOUR")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Founded in the nineteenth century as the world’s first national accounting body, the Institute of Chartered Accountants in England and Wales quickly established a dining club, sports clubs and a library. Among the library’s first acquisitions was a copy of Luca Pacioli’s ground-breaking Renaissance book of practical mathematics, "), _c('em', [_vm._v("Summa de Arithmetica")]), _vm._v(" (1494).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Summa de Arithmetica")]), _vm._v(" explains how to manage ledgers, inventories, liabilities and expense accounts. As well as pioneering the use of Hindu– Arabic numerals in Europe, it helped popularise double-entry accounting. ‘For every credit in a ledger,’ Pacioli wrote, ‘there must also be a debit.’ The enlightened author encouraged entrepreneurs to stop consulting astrologers and recluses for advice about this or that venture; all a merchant needed to succeed, Pacioli counselled, was access to cash, a good bookkeeper and an up-to-date system of accounts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pacioli belonged to a noble tradition of scholarship. Bookkeeping – along with cartography, perspective and ballistics – was one of the first sciences of the scientific revolution. The German polymath Johann Wolfgang von Goethe considered double-entry bookkeeping ‘amongst the finest inventions of the human mind’.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Curiously, the careful counting of money preceded the careful measurement of lunar movements and accelerating cannonballs. The physical sciences, such as astronomy and physics, drew heavily on fiscal precedents: several pioneer physicists and cosmographers had also learned economics and accounting. Copernicus, for example, wrote on monetary reform as well as on the planets. Galileo taught bookkeeping, and learnt much from the field.")]), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn-1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" In 1696 Sir Isaac Newton was appointed Warden of England’s Royal Mint."), _c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn-2"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the early days of science, numbers were put to all manner of purposes, practical and impractical. The first Latin and Italian books on arithmetic also instructed their readers on conjuring, astrology, thaumaturgy, games, jests, curses and black magic. As we look back with modern eyes, the line between early mathematics and magic appears strikingly fine; indeed, the relationship between math and the occult has a long history. Early in the fifth century, St Augustine issued a warning: ‘The good Christian should beware of mathematicians and all those who make empty prophecies. The danger already exists that mathematicians have made a covenant with the devil to darken the spirit and confine man in the bonds of Hell.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When, in the thirteenth century, Roger Bacon advocated the adoption of the Hindu–Arabic numerals, the church accused him of practising magic and condemned him to life in prison. Long after those strange-looking numerals arrived in Europe, they were still seen as exotic, even disreputable. The numerals, though, were a boon for Western culture. Much more practical and versatile than the Roman ones, the Asian numerals opened the way for modern mathematics, and hence modern accounting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Double-entry bookkeeping rests on a tautology: the value of an organisation’s assets must equal the claims of creditors and owners to those assets. This was a new idea. Earlier financial records reflected a very different philosophy. The Domesday Book of 1086, for example, is a set of simple lists that assert King William’s property rights, ecclesiastical rights, legal privileges, taxes and commitments. It is not a balanced schedule of debits and credits. Absolute rulers were more interested in counting their gold than in tallying their debts – that is, in reckoning what they owned rather than what they owed. The rise of double-entry among bankers and merchants in the late medieval period reflected the tectonic social, political and economic changes of the age, and the shift of power to the men and women who energised the Renaissance.")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Pacioli volume became one of the most valued possessions of the Institute of Chartered Accountants, both for its ground-breaking content and for its worth on the rare book market. An ‘incunabulum’ (meaning it was printed before 1501), the book is today appreciated as one of the earliest printed volumes about numbers. Another copy, finely bound in vellum and recently found in an old cupboard, sold at a Milan book auction for 530,000 euros. These volumes are rare survivors: most other copies from the 1494 edition were read to pieces by teachers, students, bookkeepers and merchants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The institute’s other treasures include "), _c('em', [_vm._v("Nieuwe Instructie")]), _vm._v(" (Antwerp, 1543), a work whose translation into French and English helped spread double-entry accounting to Western Europe (the author was Jan Ympyn Christoffels, a travelling silk trader), and the only surviving complete copy of "), _c('em', [_vm._v("The maner and fourme how to kepe a perfecte reconying")]), _vm._v(" (London, 1553), written by James Peele and adorned with elegant sample ledgers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("The institute’s collection would be described in 1966 as the world’s most complete library devoted to accounting and allied subjects. It is a monument to a powerful principle: that sound bookkeeping is the foundation of success in statecraft and in commerce. The modern ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("accounting profession was built upon this principle. Firms promised to guide their clients through a perilous terrain, and towards a noble goal. The four largest accounting and audit firms have profited spectacularly from widespread confidence in this idea. How well founded is that confidence? How fit are the big firms as trustworthy guides? And how stable is their position as the heirs to Pacioli and Christoffel and Peele?")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('div', {
    staticClass: "line"
  }, [_c('hr')])]), _c('p', {
    staticClass: "fnnote"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "fn-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(" He also taught the new mathematics of fortification, such as how to build ‘star forts’ to withstand artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "fnnote"
  }, [_c('a', {
    attrs: {
      "id": "fn-2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(" The mathematician Carl Friedrich Gauss is said to have pointed out an error in his father’s financial calculations – at the age of three.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0994caff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prelude.vue
// module id = 72
// module chunks = 0